import React from 'react'

const ScanAssetScreen = () => {
  return (
    <div>
    </div>
  )
}

export default ScanAssetScreen
